import { makeAutoObservable } from "mobx";
import { Money } from "../../core";
import { parseServiceFeeQuote } from "../../ordering";
import { POrderInfoOrderLine } from "./POrderInfoOrderLine";
export class POrderInfo {
    constructor(params) {
        this.localizationProvider = params.localizationProvider;
        this.orderInfo = params.orderInfo;
        makeAutoObservable(this);
    }
    get orderLines() {
        const items = this.orderInfo.items.map((item) => {
            var _a;
            return new POrderInfoOrderLine({
                localizationProvider: this.localizationProvider,
                name: item.name,
                quantity: item.quantity,
                price: item.total,
                description: (_a = item.description) !== null && _a !== void 0 ? _a : null,
            });
        });
        const discounts = this.orderInfo.discounts.map((item) => new POrderInfoOrderLine({
            localizationProvider: this.localizationProvider,
            name: item.name,
            quantity: null,
            price: -item.value,
            description: null,
        }));
        return [...items, ...discounts];
    }
    get deliveryCost() {
        return this.localizationProvider.formatPrice(Money.fromBackend(this.orderInfo.deliveryCost));
    }
    get tipValue() {
        return this.orderInfo.tip !== null
            ? this.localizationProvider.formatPrice(Money.fromBackend(this.orderInfo.tip.contents))
            : null;
    }
    get paymentTotal() {
        return this.localizationProvider.formatPrice(Money.fromBackend(this.orderInfo.paymentTotal));
    }
    get serviceFeeValue() {
        return this.orderInfo.serviceFee !== null
            ? this.localizationProvider.formatPrice(Money.fromBackend(this.orderInfo.serviceFee.value))
            : null;
    }
    get serviceFeeQuote() {
        if (this.orderInfo.serviceFee === null) {
            return null;
        }
        return parseServiceFeeQuote(this.orderInfo.serviceFeeQuote);
    }
    get serviceFeePercentage() {
        const quote = this.serviceFeeQuote;
        return quote !== null
            ? this.localizationProvider.formatPercentage(quote.percentage.value)
            : null;
    }
    get serviceFeeMinPrice() {
        const quote = this.serviceFeeQuote;
        return quote !== null
            ? this.localizationProvider.formatPrice(quote.min)
            : null;
    }
    get serviceFeeMaxPrice() {
        const quote = this.serviceFeeQuote;
        return quote !== null
            ? this.localizationProvider.formatPrice(quote.max)
            : null;
    }
    get depositTotal() {
        return this.orderInfo.depositTotal > 0
            ? this.localizationProvider.formatPrice(Money.fromBackend(this.orderInfo.depositTotal))
            : null;
    }
    get orderId() {
        return this.orderInfo.id;
    }
    get isOnlinePayment() {
        return this.orderInfo.onlinePayment;
    }
    get origin() {
        return this.orderInfo.origin;
    }
}
